var render = function (_h,_vm) {var _c=_vm._c;return _c('polygon',{attrs:{"points":"25.74 0 24.26 0 7.82 16.91 9.78 19.04 22.77 8.25 22.77 50 27.23 50 27.23 8.25 40.22 19.04 42.18 16.91 25.74 0"}})}
var staticRenderFns = []

export { render, staticRenderFns }